import { useId } from 'react';
import cn from 'classnames';
import styles from 'components/Checkbox/Checkbox.scss';

export const Checkbox = ({
  className,
  label,
  icon,
  onChange,
  disabled = false,
  checked = false,
  id: propId,
  smallStyle,
  ...props
}) => {
  const generatedId = useId();
  const id = propId || generatedId;

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      onChange?.({
        ...e,
        target: {
          ...e.target,
          checked: !checked,
        },
      });
    }
  };

  return (
    <label
      htmlFor={id}
      className={cn(styles.checkbox, className, {
        [styles.disabled]: disabled,
        [styles.checked]: checked,
        [styles.small]: smallStyle,
      })}
      tabIndex={disabled ? -1 : 0}
      onKeyDown={handleKeyDown}
      data-testid='checkbox-label'
    >
      <input
        type='checkbox'
        id={id}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
        className={styles.hiddenInput}
        aria-checked={checked}
        readOnly={onChange ? false : true}
        {...props}
      />
      <span className={styles.customCheckbox} aria-hidden>
        <span className={styles.checkmark}>
          {icon || <span className={cn(styles.defaultCheck, { [styles.checked]: checked })} />}
        </span>
      </span>
      {label && <span className={styles.labelText}>{label}</span>}
    </label>
  );
};
